/**
 * The product mark, drawn in `currentColor` so it can sit on the accent tile in
 * the sidebar, on the boot screen, or anywhere else at any size. It restates
 * the bulb of the original logo as a single stroke with a pulse through it.
 */
export const BrandMark = ({ className }: { className?: string }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        <path d="M12 2.6a6.9 6.9 0 0 0-3.9 12.6c.5.4.8 1 .8 1.6v.5h6.2v-.5c0-.6.3-1.2.8-1.6A6.9 6.9 0 0 0 12 2.6Z" />
        <path d="M9.5 20h5M10.4 22.2h3.2" />
        <path d="M8.6 10.4h1.7l1-2.3 1.5 4.3 1-2h1.6" />
    </svg>
);
